import { render } from "./SlipInputDlg.vue?vue&type=template&id=c8c32a1a&scoped=true"
import script from "./SlipInputDlg.vue?vue&type=script&lang=js"
export * from "./SlipInputDlg.vue?vue&type=script&lang=js"

import "./SlipInputDlg.vue?vue&type=style&index=0&id=c8c32a1a&scoped=true&lang=css"

import exportComponent from "/frontside/account/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c32a1a"]])

export default __exports__